<div class="item-score enviroment" [ngClass]="{ 
                                                'completed': current === total,
                                                'loading-steps': isLoadingSteps
                                              }">
  <svg class="circular-chart" viewBox="0 0 36 36">
    <path class="circle-bg" d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
        a 15.9155 15.9155 0 0 1 0 -31.831" [attr.stroke-dasharray]="100"></path>
    <path class="circle" *ngIf="current > 0" d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
        a 15.9155 15.9155 0 0 1 0 -31.831" [attr.stroke-dasharray]="getCompletedCircle()"></path>
    <text x="18" y="18.5" text-anchor="middle" class="upper-text"
      [attr.fill]="current === total ? '#10dc60' : '#727272'">
      {{ current }}/{{ total }}
    </text>
    <text x="18" y="22" text-anchor="middle" class="lower-text" [attr.fill]="current === total ? '#10dc60' : '#001e62'">
      {{ 'performanceCycles.finished' | translate }}
    </text>
  </svg>
</div>